<div class="d-flex justify-content-center align-items-center min-vh-100 bg-image">

  <div class="error-main-section flr flex-direction-column ">
    <img src="assets/error-page.png" alt="" class="width-50 error-page-image"
         style="position: absolute; margin-top: -120px;"/>

    <div class="error-page">
      <div class="error-info-container">
        <h2 class="error-page-message">Page Not Found</h2>
        <span class="description">
          Oops! Something went wrong.<br>
        We couldn’t find the page you are looking for.</span>
      </div>
      <button routerLink="/cards" class="back-button">
        Go Back
      </button>
    </div>
  </div>
</div>
